import type { SvgProps } from '@/types/svgs/svg-types';
import { SwjIconRadioBase } from './swj-icon-radio-base';

const boltPath =
    'M19.81 11.08C19.97 10.89 20.23 10.85 20.43 10.94C20.63 11.04 20.75 11.25 20.69 11.47L19.01 16.75H22.61C22.82 16.75 23.01 16.88 23.09 17.08C23.17 17.28 23.12 17.51 22.95 17.66L16.26 24.92C16.14 25.05 15.98 25.11 15.81 25.11C15.72 25.11 15.63 25.09 15.55 25.04C15.35 24.95 15.24 24.74 15.29 24.52L16.97 19.24H13.37C13.16 19.24 12.97 19.11 12.89 18.91C12.81 18.71 12.86 18.48 13.03 18.33L19.81 11.08Z';

export const SiteWideJackpotBoltRadio = ({ width, height }: SvgProps) => (
    <SwjIconRadioBase width={width} height={height} testId="site-wide-jackpot-bolt-radio">
        <g filter="url(#filter1_ii_8601_70075)">
            <path d={boltPath} fill="white" />
        </g>
    </SwjIconRadioBase>
);

export default SiteWideJackpotBoltRadio;
